import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "../../../services/reactQuery/reactQueryService";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { caseHasUnreadMessage } from "../../../services/messagingService";
import ProductBoxGrid from "@/src/components/ProductBoxGrid/ProductBoxGrid";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type NewMessageCaseBoxProps = {
  product: AbstractCase;
};
export default function NewMessageCaseBox({ product }: NewMessageCaseBoxProps) {
  const { data: conversations, isLoading } = useQuery({
    queryKey: queryKeys.collection("/conversations"),

    queryFn: () => fetchCollection("/conversations"),
  });

  if (isLoading || !conversations) {
    return null;
  }

  if (!caseHasUnreadMessage(product.id, conversations)) {
    return null;
  }

  return (
    <ProductBox headline={"Neue Nachricht"}>
      <ProductBoxGrid
        items={[
          <Typography>Es liegt eine neue Nachricht für Sie vor. Sie finden diese in Ihrem Nachrichtenbereich.</Typography>,
          <Button variant={"contained"} fullWidth component={Link} to={"/servicewelt/nachrichten?caseId=" + product.id}>
            Nachricht lesen
          </Button>,
        ]}
      />
    </ProductBox>
  );
}
